import { render, staticRenderFns } from "./ActivityItemChip.vue?vue&type=template&id=95452256&"
import script from "./ActivityItemChip.vue?vue&type=script&lang=js&"
export * from "./ActivityItemChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports